import { api } from "./api";

export const listStoreData = async (): Promise<any> => {
  const { data } = await api.get("/store/data");
  return data;
};
